import { useContext } from 'react';
import UserContext from '../../contexts/UserContext';

const useActiveResident = () => {
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);

    const activeResident = listOfResidents[activeRegistrantsIndexes[0]];

    return activeResident;
};

export default useActiveResident;
